'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path stroke="currentColor" d="M2.5 2.5c0-.502.402-.9 1-1l7.5-1 7.5 1c.603.1 1 .504 1 1v7c0 8.45-7.5 12-8.5 12s-8.5-3.55-8.5-12zm16 7v-7l-7.498-1-7.502 1v7c0 7.45 6.5 11 7.5 11s7.5-3.55 7.5-11Z" /><path stroke="currentColor" strokeWidth={4} d="M16.999 12c0 3-3.065 6-3.999 6v-6zM9 3v5H5V3.818z" /></svg>;
const IconAdminShield = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconAdminShield;